import React, { Component } from 'react';


// Third Party
// import { FaLinkedin } from 'react-icons/fa';

class DaltonCard extends Component {
    state = {
        headerShrink: false,
        daltonGrow: false,
    }
    componentDidMount() {
        window.addEventListener('scroll', this.growDalton);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.growDalton);
    }

    growDalton = (e) => {
        if(window.scrollY > 150){
          this.setState({
            daltonGrow: true,
          })
        }else{
          this.setState({
            daltonGrow: false,
          })
        }
      }
  render() {
    return (
      <div className={'dalton-card-container'}>
          <div className={'dalton-card-img-side'}>
                <img
                    className={this.state.daltonGrow ? 'dalton-card-foreground-img-zoom' :'dalton-card-foreground-img'}  
                    src={'https://res.cloudinary.com/du9tnv8ss/image/upload/v1752609073/me_no_bg_w45wzs.webp'}
                />
            </div>
          <div class="dalton-text-view">
              <h2 className="dalton-header"> I design and build fast, intuitive front-end experiences that users enjoy.</h2>
              <p className="dalton-copy"> I am a Front-End Engineer with a passion for building high-performance web and mobile experiences. 
                  Experienced in React, React Native, and rapid prototyping, 
                  with a strong eye for UX and a track record of delivering impactful features across startups and large-scale platforms.</p>
          </div>
      </div>
    );
  }
}

export default DaltonCard;



// WEBPACK FOOTER //
// ./src/components/DaltonCard.js